<template>
  <div
    id="agentCreateExcelModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <!--begin::Form-->
      <form class="kt-form" @submit="formSubmit">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{this.$route.meta.breadcrumb}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label class="label-required">ยังไม่เปิดใช้งาน</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> บันทึกข้อมูล
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: function() {
    return {
      // userName: null,
      // password: null,
      // confirmPassword: null,
      // email: null,
      // givenName: null,
      // familyName: null,
      // position: null,
      // phoneNumber: null,
      // roleName: null
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$("#agentCreateModal form")
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      let router = this.$router;
      axios
        .post("/Api/Users/Create", {
          userName: this.userName,
          password: this.password,
          confirmPassword: this.confirmPassword,
          email: this.email,
          givenName: this.givenName,
          familyName: this.familyName,
          position: this.position,
          phoneNumber: this.phoneNumber,
          roleName: this.roleName
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $("#holdCreateModal").modal("hide");
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    $("#dateType").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true
    });

    // set validation rules
    $("#agentCreateModal form").validate({
      // rules: {
      //   userName: "required",
      //   email: {
      //     required: true,
      //     email: true
      //   },
      //   password: {
      //     required: true,
      //     minlength: 6
      //   },
      //   confirmPassword: {
      //     equalTo: "#password"
      //   },
      //   givenName: "required",
      //   familyName: "required",
      //   phoneNumber: "required"
      // },
      // messages: {
      //   userName: "กรุณากรอกชื่อผู้ใช้งาน (Username)",
      //   email: {
      //     required: "กรุณากรอกอีเมล",
      //     email: "กรุณากรอกอีเมลให้ถูกต้อง"
      //   },
      //   password: {
      //     required: "กรุณากรอกรหัสผ่าน",
      //     minlength: "รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร"
      //   },
      //   confirmPassword: {
      //     equalTo: "กรุณากรอกรหัสผ่านให้ตรงกันทั้ง 2 ช่อง"
      //   },
      //   givenName: "กรุณากรอกชื่อ",
      //   familyName: "กรุณากรอกชื่อสกุล",
      //   phoneNumber: "กรุณากรอกเบอร์โทรศัพท์"
      // }
    });
    $("#agentCreateExcelModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        self.$parent.reloadDataTable(false);
      })
      .modal("show");
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Agent/AgentCreateExcel.vue